export enum EformAvisLiesType {
	CONCURRENCE = 'CONCURRENCE',
	CONCURRENCE_ASSOUPLI = 'CONCURRENCE_ASSOUPLI',
	RESULTAT = 'RESULTAT',
	MODIF_MARCHE = 'MODIF_MARCHE'
}
